(() => {
  const updateGallery = gallery => {
    const carousel = gallery.querySelector('scroll-carousel');
    if (!carousel) return;
    gallery.closest('.product')?.style.setProperty('--sd-pdp-gallery-height', `${gallery.getBoundingClientRect().height}px`);
    gallery.querySelectorAll('[data-sd-gallery-direction]').forEach(button => {
      const direction = Number(button.dataset.sdGalleryDirection);
      button.disabled = direction < 0 ? carousel.scrollLeft < 2 : carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 2;
    });
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-sd-gallery-direction], [data-sd-cross-direction]');
    if (!button) return;
    const gallery = button.closest('product-gallery');
    const carousel = gallery ? gallery.querySelector('scroll-carousel') : button.closest('.sd-routine-complements')?.querySelector('.sd-routine-complements__list');
    if (!carousel) return;
    const item = [...carousel.children].find(element => !element.hidden);
    const distance = (item?.getBoundingClientRect().width || carousel.clientWidth) + (parseFloat(getComputedStyle(carousel).columnGap) || 0);
    carousel.scrollBy({left:distance * Number(button.dataset.sdGalleryDirection || button.dataset.sdCrossDirection),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  });
  document.addEventListener('scroll', event => {
    if (event.target.matches?.('.product-gallery__carousel')) updateGallery(event.target.closest('product-gallery'));
  }, true);
  const gallerySizes = new ResizeObserver(entries => entries.forEach(entry => updateGallery(entry.target)));
  const init = () => document.querySelectorAll('.shopify-section--main-product product-gallery').forEach(gallery => { updateGallery(gallery); gallerySizes.observe(gallery); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('resize', init);
})();


document.addEventListener('click', event => {
  const readMore = event.target.closest('[data-sd-read-more]');
  if (readMore) {
    const target = document.getElementById(readMore.hash.slice(1));
    if (target) {
      event.preventDefault();
      const description = target.querySelector('details');
      if (description) description.open = true;
      target.tabIndex = -1;
      target.focus({preventScroll:true});
      target.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      history.replaceState(null,'',readMore.hash);
    }
    return;
  }
  const opener = event.target.closest('[data-sd-snow-open]');
  if (opener) {
    const dialog = document.getElementById(opener.dataset.sdSnowOpen);
    if (dialog instanceof HTMLDialogElement && !dialog.open) dialog.showModal();
    return;
  }
  const closer = event.target.closest('[data-sd-snow-close]');
  if (closer) closer.closest('dialog')?.close();
  if (event.target instanceof HTMLDialogElement && event.target.classList.contains('sd-snow-drawer')) {
    const rect = event.target.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
  }
});

